import { convertMarketplace, setMarketplace } from '@spike/marketplace-action';
import { setTimeZone } from 'actions/login/LoginActions';
import { showWarning } from '@spike/notifications-action';
import { useAuth, useMasterData } from 'hooks';
import { MarketplaceWebSocketsMessage } from 'model/WebSockets';
import { FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { websocketLog } from './websocketLog';
import { useActionCableChannel } from './useActionCableChannel';

const MarketplaceWebSockets: FunctionComponent = () => {
    const masterData = useMasterData();
    const auth = useAuth();
    const history = useHistory();
    const dispatch = useDispatch();

    const onReceived = useCallback(
        (message: MarketplaceWebSocketsMessage) => {
            websocketLog('message', 'MarketplaceWebSockets', { marketplaceId: message.marketplace?.id });

            const marketplace = convertMarketplace(message.marketplace, masterData);

            if (auth.timeZone && auth.timeZone !== marketplace.schedule.timeZone) {
                dispatch(showWarning('Time Zone has changed! Please login in again.'));
                setTimeout(() => history.push('/logout'), 1500);
            } else {
                dispatch(setMarketplace(marketplace));
                setTimeZone(marketplace.schedule.timeZone, marketplace.id!, dispatch);
            }
        },
        [auth.timeZone, dispatch, history, masterData]
    );

    useActionCableChannel<MarketplaceWebSocketsMessage>({
        channel: 'MarketplaceChannel',
        params: { marketplace_id: auth.marketplaceId },
        enabled: Boolean(auth.signedIn && auth.marketplaceId),
        onReceived,
        subscriptionDeps: [auth.marketplaceId],
        logLabel: 'MarketplaceWebSockets'
    });

    return null;
};

export default MarketplaceWebSockets;
